<div class="container">
  <div class="flex-titulo">
    <h1>Nueva configuración de dosier</h1>
    <div class="flex-end">
      <app-selector [textoOpcion1]="''" [textoOpcion2]="'Activado'" [active]="activado" [control]="'estado'" (mostrarSeleccion)="toggleActivado($event)"></app-selector>
    </div>
  </div>
  <div *ngIf="cargando" class="spinner-container">
    <mat-spinner diameter="30" strokeWidth="2"></mat-spinner>
  </div>
  <div *ngIf="!cargando">

    <div class="content">
      <form [formGroup]="formularioEnvioService.formularioEnvio">

        <!-- Nombre -->
        <div class="container-seccion">
          <div class="container-seccion-titulo">
            <h2>Nombre del dosier</h2>
          </div>
          <div class="container-white">
            <input id="nombre" type="text" formControlName="nombre" [ngClass]="(formularioValidacionesService.isCampoValido('nombre') || errorNombre) ? 'errorInput':'' " >
            <br>
            <span class="texto-validacion" *ngIf="formularioValidacionesService.isCampoValido('nombre') || errorNombre">
              {{formularioValidacionesService.mensajeErrorNombre}}
              </span>
          </div>
        </div>

        <!-- Fin nombre -->

        <!-- Envío XML -->
        <div *ngIf="moduloXmlActivo">
          <div class="container-seccion">
            <div class="container-seccion-titulo">
              <h2>Envío desasistido por XML</h2>
              <p class="subtitulo">Habilita la posibilidad de realizar envíos de firma desde tu aplicación de gestión sin tener que acceder a Hire & Sign</p>
            </div>
            <div class="container-white">
              <div class="checkboxAjustes">
                <input type="checkbox" formControlName="envioXml">
                <label for="envioXml">Habilitado</label>
              </div>
              <p class="xml-p">Texto por el que empieza el fichero XML que genera tu aplicación</p>
              <p class="subtitulo xml-sub">Hire & Sign va a enviar este dosier cada vez que encuentre un fichero .xml cuyo nombre empiece por estos carácteres</p>
              <input id="nombreComienzaLibra" type="text" formControlName="nombreComienzaLibra" [ngClass]="formularioValidacionesService.isCampoValido('nombreComienzaLibra') ? 'errorInput':'' " >
              <br>
              <span class="texto-validacion" *ngIf="formularioValidacionesService.isCampoValido('nombreComienzaLibra')">
                {{formularioValidacionesService.mensajeErrorNombreComienzaLibra}}
                </span>
            </div>
          </div>
        </div>

        <!-- Fin Envío XML -->

        <!-- Destinatarios -->
        <div class="container-seccion">
          <div class="container-seccion-titulo">
            <h2>Destinatarios</h2>
          </div>
          <div id="destinatarios" class="container-white">
            <!-- <app-firmantes [totalFirmantes]="firmantes" [hayCopiaBasica]="hayCopiaBasica"></app-firmantes> -->
            <app-firmantes [totalFirmantes]="formularioEnvioService.firmantes.value" [hayCopiaBasica]="hayCopiaBasica"></app-firmantes>
          </div>
        </div>
        <!-- Fin destinatarios -->

        <!-- Modo de envio -->
        <div class="container-seccion">
          <div class="container-seccion-titulo">
            <h2>Modo de envío</h2>
            <p class="subtitulo">Activa o desactiva distintos modos de envío.</p>
          </div>
          <div id="modo-envio" class="container-white">
            <p style="padding-left: 20px; margin-top:0;">Este dosier estará disponible para su envío en modo:</p>
            <div class="input-modo-envio" style="margin-bottom: 10px;">
              <div class="input-radio" [ngClass]="moduloSmsActivo ? '':'desactivado'">
                <input type="checkbox" name="envioMail" formControlName="envioMail" (change)="getCheckboxValue($event, 'MAIL')">
              </div>
              <label for="envioMail">Correo electrónico</label>
            </div>
            <div class="orden-envio">
              <div [ngClass]=" {'desactivado': !envioMail.value}">
                <app-drop-down-single-con-id [data]="tipoMailsString"
                                            [tituloHorizontal]="'E-mail usado:'"
                                            (elementoSeleccionado)="onMailSeleccionado($event, 'email')"
                                            [valorPreSeleccionado]="formularioEnvioService.ordenMailPreSeleccionado"
                                            [refreshKey]="formularioEnvioService.mailRefreshKey"
                                            [width]="'300px'"
                                            [height]="'30px'"
                                            [borderStyle]="'1px solid #D0D0D0'"
                                            [errorClass]="formularioValidacionesService.isCampoValido('ordenMail') ? 'errorInput':''"
                                            >
                </app-drop-down-single-con-id>
              </div>
              <span class="texto-validacion" *ngIf="formularioValidacionesService.isCampoValido('ordenMail')">
                {{formularioValidacionesService.mensajeErrorMail}}
              </span>
            </div>
            <div>
              <div class="input-modo-envio" style="margin-bottom: 10px;">
                <div class="input-radio" [ngClass]="moduloSmsActivo ? '':'desactivado'" style="margin-bottom:3px;">
                  <input type="checkbox" name="envioSMS" formControlName="envioSMS" (change)="getCheckboxValue($event, 'SMS')">
                </div>
                <label for="envioSMS" [ngClass]="moduloSmsActivo ? '':'desactivado'">SMS</label>
                <span *ngIf="!moduloSmsActivo" class="infoSMS tooltip">
                  <svg class="icon-help">
                    <use xlink:href="#hs-help"></use>
                  </svg>
                  <app-custom-tooltip-sqp [textoTooltip]="'sms'" [posicion]="'right'"></app-custom-tooltip-sqp>
                </span>
              </div>
              <div class="orden-envio" [ngClass]="{'desactivado': !envioSMS.value || !moduloSmsActivo }">
                <app-drop-down-single-con-id [data]="tipoMailsString"
                                            [tituloHorizontal]="'Teléfono usado:'"
                                            (elementoSeleccionado)="onMailSeleccionado($event, 'sms')"
                                            [valorPreSeleccionado]="formularioEnvioService.ordenSmsPreSeleccionado"
                                            [refreshKey]="formularioEnvioService.smsRefreshKey"
                                            [width]="'300px'"
                                            [height]="'30px'"
                                            [borderStyle]="'1px solid #D0D0D0'"
                                            [errorClass]="formularioValidacionesService.isCampoValido('ordenTelefonoSMS') ? 'errorInput':''"
                                            >
                </app-drop-down-single-con-id>
                <span class="texto-validacion" *ngIf="formularioValidacionesService.isCampoValido('ordenTelefonoSMS')">
                  {{formularioValidacionesService.mensajeErrorOrdenTelefonoSMS}}
                </span>
              </div>
              <div style="margin-left: 5px; margin-top: 20px; margin-bottom: 10px;">
                <app-selector [ngClass]=" {'desactivado': !envioMail.value}" id="selector-envioSecurizado" [textoOpcion1]="''" [textoOpcion2]="'Enviar código de verificación por SMS para acceder a la firma (OTP)'" [active]="securizadoSMS.value" [control]="'estado'" (mostrarSeleccion)="enableEnvioSecurizadoSMS($event)"></app-selector>
              </div>
              <div class="orden-envio" [ngClass]=" {'desactivado': !securizadoSMS.value}">
                <app-drop-down-single-con-id [data]="tipoMailsString"
                                            [tituloHorizontal]="'Teléfono usado:'"
                                            (elementoSeleccionado)="onMailSeleccionado($event, 'otp')"
                                            [valorPreSeleccionado]="formularioEnvioService.ordenOtpPreSeleccionado"
                                            [refreshKey]="formularioEnvioService.otpRefreshKey"
                                            [width]="'300px'"
                                            [height]="'30px'"
                                            [borderStyle]="'1px solid #D0D0D0'"
                                            [errorClass]="formularioValidacionesService.isCampoValido('ordenTelefonoOTP') ? 'errorInput':''"
                                            >
                  </app-drop-down-single-con-id>
                <span class="texto-validacion" *ngIf="formularioValidacionesService.isCampoValido('ordenTelefonoOTP')">
                  {{formularioValidacionesService.mensajeErrorOrdenTelefonoOTP}}
                </span>
              </div>

              <div *ngIf="envioMail.value && envioSMS.value">
                <p style="padding-left: 20px; margin-top: 20px;">El modo de envío por defecto será:</p>
                <div class="input-modo-envio">
                  <div class="input-radio">
                    <input type="radio" name="canalEnvioActivo" formControlName="canalEnvioActivo" [value]="'MAIL'">
                  </div>
                  <label for="canalEnvioActivo">Correo electrónico</label>
                </div>
                <div class="input-modo-envio" style="margin-top:10px;">
                  <div class="input-radio">
                    <input type="radio" name="canalEnvioActivo" formControlName="canalEnvioActivo" [value]="'SMS'">
                  </div>
                  <label for="canalEnvioActivo">SMS</label>
                </div>
              </div>
            </div>

          </div>
        </div>
        <!-- Fin modo de envio -->

        <!-- Subject -->
        <div class="container-seccion">
          <div class="container-seccion-titulo">
            <h2>Mensaje</h2>
            <p class="subtitulo">Texto que verán los destinatarios al recibir la comunicación.</p>
          </div>
          <!-- <div class="container-white"> -->
            <div *ngIf="envioMail.value || (!envioMail.value && !envioSMS.value)" class="container-white">
              <label for="subject">Asunto del correo electrónico</label>
              <div style="margin-bottom: 20px;">
                <input id="subject" type="text" formControlName="subject">
              </div>
              <label for="mensaje">Cuerpo del mensaje del correo electrónico</label>
              <div class="flex-input">
                <textarea id="body" formControlName="body"></textarea>
              </div>
            </div>
          <!-- </div> -->
          <!-- Fin subject -->

          <!-- Body del email -->
          <!-- <div *ngIf="envioMail.value || (!envioMail.value && !envioSMS.value)" style="padding: 20px">
            <label for="mensaje">Cuerpo del mensaje del correo electrónico</label>
            <div class="flex-input">
              <textarea id="body" formControlName="body"></textarea>
            </div>
          </div> -->
          <!-- <div *ngIf="envioSMS.value" [ngStyle]="{ 'margin-top': (envioMail.value ? '20px' : '0px') }"> -->
          <!-- <div *ngIf="envioSMS.value" [ngStyle]="{ 'margin-top': (envioMail.value ? '20px' : '0px') }"> -->
          <div *ngIf="envioSMS.value" class="container-sms" [ngStyle]="{ 'padding-top': (envioMail.value && envioSMS.value ? '0px' : '20px') }">
            <label for="mensaje">Cuerpo del mensaje de SMS (110 carácteres máximo)</label>
            <p class="subtitulo">El enlace para acceder a los documentos se añadirá después del texto</p>
            <div class="flex-input textarea-container">
              <textarea id="bodySMS" formControlName="bodySMS" [ngClass]="{'errorInput':formularioValidacionesService.isCampoValido('bodySMS')}"></textarea>
              <span class="char-counter">{{ characterCount }}/110</span>
            </div>
            <span class="texto-validacion" *ngIf="formularioValidacionesService.isCampoValido('bodySMS')">
              {{formularioValidacionesService.mensajeErrorBodySMS}}
            </span>
          </div>

        </div>
        <!-- Fin body del e-mail -->

        <!-- Documentos adjuntos -->
        <div class="container-seccion">
          <div class="container-seccion-titulo">
            <h2>Documentos adjuntos</h2>
            <p *ngIf="!envio?.esRLT" class="subtitulo">Puedes crear un nuevo documento o seleccionar uno ya existente en otro envío. También los puedes fusionar en uno solo.</p>
          </div>
          <div id="docs-adjuntos">
            <div *ngIf="documentosEnvio.length>0" id="documentos">
                <app-grupo-docs [totalDocumentos]="documentosEnvio" (docEliminadoEmitter)="refresh()"></app-grupo-docs>
            </div>
            <div *ngIf="!envio?.esRLT" class="anadir-docs">
              <label for="">Añadir documentos</label>
              <div class="flex-docs-adjuntos">
                <app-boton-accion id="addExistenteId" mat-button (botonClicked)="anadirDocExistente()" [titulo]="'Documentos existentes'" [outline]="true"[outlineYellow]="true" [cancelar]="false"></app-boton-accion>
                <app-boton-accion id="addNuevoId" mat-button (botonClicked)="anadirNuevoDoc()" [titulo]="'Nuevo documento'" [outline]="true"[outlineYellow]="true" [cancelar]="false"></app-boton-accion>
              </div>
            </div>
          </div>
        </div>
        <!-- Fin documentos adjuntos -->

        <!-- Ajustes -->
        <div class="container-seccion">
          <div class="container-seccion-titulo">
            <h2>Ajustes adicionales</h2>
          </div>
          <div id="ajustes" class="container-white">
            <!-- Recordatorios programados -->
            <h3>Recordatorios programados</h3>
            <div class="checkboxAjustes">
              <input type="checkbox" formControlName="recordatorio" (click)="formularioValidacionesService.getCheckboxClick('recordatorio'); clickAvisoFirma()">
              <label for="recordatorio">Activar recordatorios</label>
            </div>
            <div *ngIf="recordatorio.value">
              <div class="diasEnvio">Días tras el envío</div>
              <div class="input-ajustes">
                <app-envios-recordatorios *ngFor="let recordatorio of formularioEnvioService.recordatorios; index as i" [indexAviso]="i" (eliminar)="eliminarAviso($event)" (update)="updateAviso($event)" [numAviso]="recordatorio"></app-envios-recordatorios>
                <div>
                  <p class="link-agregar" (click)="agregarAviso()">Añadir otro aviso</p>
                </div>


              </div>
              <span class="texto-validacion val-avisos" *ngIf="formularioValidacionesService.validacionAvisos()">
                {{formularioValidacionesService.mensajeErrorAvisosFirma}}
              </span>
            </div>
            <!-- Fin recordatorios programados -->

            <!-- Envío universal -->
            <h3 style="margin-top: 20px">Envío universal</h3>
            <div class="checkboxAjustes">
              <input type="checkbox" formControlName="envioMasivo">
              <label for="envioMasivo">Activar envío universal</label>
            </div>
            <!-- Fin envío universal -->

            <!-- Caducidad -->
            <h3 style="margin-top: 20px; margin-bottom: 10px">Caducidad</h3>
            <div class="checkboxAjustes">
              <input class="input-caducidad" type="number" formControlName="caducidad" [ngClass]="formularioValidacionesService.isCampoValido('caducidad') ? 'errorInput':'' ">
              <label for="caducidad" style="font-weight: 400;">días</label>
            </div>
            <span class="texto-validacion" *ngIf="formularioValidacionesService.isCampoValido('caducidad')">
              {{formularioValidacionesService.mensajeErrorCaducidad}}
            </span>
            <!-- Fin caducidad -->
          </div>
        </div>
        <!-- Fin ajustes -->
      </form>
    </div>
  </div>
</div>


<app-barra-footer [id]="'nuevo envio configurado'" [icono]="'hs-send'" [titulo]="'Guardar'" [id2]="'guardar borrador'" [titulo2]="'Guardar borrador'" [icono2]="'hs-guardar'" [dobleAccion]="true" (botonClicked)="comprobarNumFirmantes()" (botonClicked2)="guardaBorrador()" class="sticky"></app-barra-footer>
